<template>
  <div
    class="input-rating"
    :class="{ 'input-rating_checked': rateFinish }"
  >
    <div
      class="input-rating__icon-wrap"
      @mouseleave="onIconWrapMouseLeave"
    >
      <i
        v-for="i in 10"
        :key="i"
        class="icon icon-clew icon_norm input-rating__icon"
        :class="getIconClass(i)"
        @click="() => onIconClick(i)"
        @mouseenter="() => onIconHover(i)"
      />
    </div>
    <p class="input-rating__text">
      {{ text }}
    </p>
    <i
      v-if="rateFinish"
      class="icon icon-remove icon_small input-rating__icon-close"
      @click="onIconCloseClick"
    />
  </div>
</template>

<script>
    export default {
        name: 'InputRating',
        props: {
            value: {
                type: Number,
                default: 0,
            },
        },
        data: () => ({
            rate: 0,
            rateFinish: 0,
        }),
        computed: {
            text() {
                const plus = (this.rate === 10) ? '' : '+'
                return (this.rate) ? `${this.$t('select.rating.title')} ${this.rate}${plus}` : `${this.$t('select.rating.title')}: ${this.$t('select.rating.all')}`
            },
        },
        watch: {
            rateFinish(val) {
                this.$emit('input', val)
            },
            value(val) {
              this.rate = val
              this.rateFinish = val
            },
        },
        methods: {
            onIconCloseClick() {
                this.rate = 0
                this.rateFinish = 0
            },
            onIconWrapMouseLeave() {
                this.rate = this.rateFinish
            },
            onIconClick(i) {
                this.rate = i
                this.rateFinish = i
            },
            onIconHover(i) {
                this.rate = i
            },
            getIconClass(i) {
                if (i > this.rate) return false
                if (this.rate && this.rate >= 8) return 'input-rating__icon_good'
                if (this.rate && this.rate >= 6.0 && this.rate <= 7.9) return 'input-rating__icon_average'
                return 'input-rating__icon_bad'
            },
        },
    }
</script>

<style scoped>

</style>
